import {Grid} from '@mui/material';
import Button from '@mui/material/Button';
// ---------- components ------------------
import WhatsappImg from 'assets/img/whatsapp.svg';
import telImg from 'assets/img/tel.svg';
import gmail from 'assets/img/gmail.svg';
import Message from 'assets/img/messages-ios.svg';
import eitaa from 'assets/img/eitaa.svg';

const ShareModalStyle = {
  pTag: {
    width: '100%',

    margin: 'auto',
    overflowX: 'scroll',
    cursor: 'pointer',
  },
  shareBtns: {
    padding: '0',
    borderRadius: '50%',
    height: '50px',
    minWidth: '50px',
    background: '#F5F5F5',
    color: '#707070',
    border: '1px solid #FFFFFF',
    boxShadow: '-5px -5px 25px #FFFFFF, 5px 5px 25px rgba(172, 172, 172, 0.5)',
  },
  span: {
    color: ' #707070',
    fontSize: '7px',
    fontFamily: 'dana-bold',
    width: '100%',
    textAlign: 'center',
    marginTop: '10px',
  },
  aStyle: {
    width: '100%',
    height: '100%',
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sendWithSMS: {
    fontFamily: 'dana-bold',
    fontSize: '14px',
    color: '#753CBE',
  },
};

const ShareSocialBtns = (props) => {
  const {shareContent, smsToOtherHandler} = props;

  return (
    <Grid
      container
      sx={{
        justifyContent: 'space-between',
        mt: '18px',
        alignItems: 'center',
      }}>
      <Grid item>
        <Button
          sx={ShareModalStyle.shareBtns}
          onClick={() => smsToOtherHandler()}>
          <img src={Message} />
        </Button>
        <p style={ShareModalStyle.span}>SMS</p>
      </Grid>
      <Grid item>
        <Button sx={ShareModalStyle.shareBtns}>
          <a
            style={ShareModalStyle.aStyle}
            target='_blank'
            rel='noreferrer'
            href={`https://telegram.me/share/url?url=${shareContent}&text=${''}`}>
            <img src={telImg} />
          </a>
        </Button>
        <p style={ShareModalStyle.span}>Telegram</p>
      </Grid>
      <Grid item>
        <Button sx={ShareModalStyle.shareBtns}>
          <a
            style={ShareModalStyle.aStyle}
            target='_blank'
            rel='noreferrer'
            href={`whatsapp://send?text=${shareContent}`}
            data-action='share/whatsapp/share'>
            <img src={WhatsappImg} />
          </a>
        </Button>
        <p style={ShareModalStyle.span}>whatsapp</p>
      </Grid>
      <Grid item>
        <Button style={ShareModalStyle.shareBtns}>
          <a
            style={ShareModalStyle.aStyle}
            target='_blank'
            rel='noreferrer'
            href={`https://mail.google.com/mail/?view=cm&fs=1&to=''&su=${'گزارش اپ فری سنس'}&body=${shareContent}&bcc=''`}>
            <img src={gmail} />
          </a>
        </Button>
        <p style={ShareModalStyle.span}>Email</p>
      </Grid>
      <Grid item>
        <Button sx={ShareModalStyle.shareBtns}>
          <a
            style={ShareModalStyle.aStyle}
            target='_blank'
            rel='noreferrer'
            href={`https://eitaa.com/share/url?url=${shareContent}&text=${''}`}>
            <img src={eitaa} />
          </a>
        </Button>
        <p style={ShareModalStyle.span}>ایتا</p>
      </Grid>
    </Grid>
  );
};

export default ShareSocialBtns;
